// extracted by mini-css-extract-plugin
module.exports = {"container":"AllReviews_container__3SIW-","back":"AllReviews_back__r0_0w","navFlex":"AllReviews_navFlex__1fVBP","headerTitle":"AllReviews_headerTitle__39Ow4"};